(function () {
  function initFeed(feed) {
    if (!feed || feed.dataset.recipeFeedInit === '1') return;
    feed.dataset.recipeFeedInit = '1';

    var batch = parseInt(feed.getAttribute('data-batch'), 10) || 9;
    var selects = feed.querySelectorAll('.recipe-feed__select');
    var cards = Array.prototype.slice.call(feed.querySelectorAll('[data-recipe-card]'));
    var countEl = feed.querySelector('[data-recipe-count]');
    var emptyEl = feed.querySelector('[data-recipe-empty]');
    var moreWrap = feed.querySelector('.recipe-feed__more');
    var moreBtn = feed.querySelector('[data-recipe-more]');
    var shown = batch;

    function filters() {
      var f = {};
      selects.forEach(function (s) { if (s.value) f[s.getAttribute('data-filter')] = s.value; });
      return f;
    }

    function matches(card, f) {
      for (var key in f) {
        var raw = (card.getAttribute('data-' + key) || '').toLowerCase();
        var wanted = f[key].toLowerCase();
        // data-meal may list multiple values (space-separated) for dual tags
        var values = raw.split(/\s+/).filter(Boolean);
        if (values.indexOf(wanted) === -1) return false;
      }
      return true;
    }

    function render() {
      var f = filters();
      var matched = 0;
      cards.forEach(function (card) {
        if (matches(card, f)) {
          matched++;
          if (matched <= shown) {
            card.classList.remove('is-hidden');
          } else {
            card.classList.add('is-hidden');
          }
        } else {
          card.classList.add('is-hidden');
        }
      });
      if (countEl) countEl.textContent = matched + (matched === 1 ? ' recipe' : ' recipes');
      if (emptyEl) emptyEl.hidden = matched > 0;
      if (moreWrap) moreWrap.hidden = matched <= shown;
    }

    selects.forEach(function (s) {
      s.addEventListener('change', function () { shown = batch; render(); });
    });
    if (moreBtn) {
      moreBtn.addEventListener('click', function () { shown += batch; render(); });
    }
    render();
  }

  function initAll() {
    document.querySelectorAll('[data-recipe-feed]').forEach(initFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
